module.exports = __webpack_public_path__ + "static/media/pyautogui.839474d6.png";